export default __webpack_public_path__ + "static/media/carbae.1019047e.svg";